var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "experts-list" },
    [
      _vm.useSwiper
        ? _c(
            "swiper-container",
            {
              staticClass: "experts-list-swiper",
              attrs: {
                "slides-per-view": 1.25,
                "space-between": 15,
                "slides-offset-before": 15,
                loop: true,
              },
            },
            _vm._l(_vm.experts, function (expert, index) {
              return _c(
                "swiper-slide",
                { key: index },
                [_c("ExpertContent", { attrs: { expert: expert } })],
                1
              )
            }),
            1
          )
        : _c(
            "div",
            {
              staticClass:
                "card-deck card-deck-cols-xl-6 card-deck-cols-lg-5 card-deck-cols-md-4 card-deck-cols-sm-3",
            },
            _vm._l(_vm.experts, function (expert, index) {
              return _c("ExpertContent", {
                key: index,
                attrs: { expert: expert },
              })
            }),
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }